(ns app.front.view.property.v2.view
  (:require [app.domain.attachment.model :as attachment-model]
            [app.domain.group.config.model :as config-model]
            [app.front.ui :as ui]
            [app.front.ui.content-switcher :as ui-cs]
            [app.front.ui.modal :as ui-modal]
            [app.front.ui.section :as section]
            [app.front.ui.select :as ui-select]
            [app.front.ui.table :as ui-table]
            [app.front.ui.tiptap :as tiptap]
            [app.front.util :refer [for-frag]]
            [app.front.view.attachment.modal :as modals]
            [app.front.view.attachment.subs :as attachment-subs]
            [app.front.view.complaint.complaints-section :as complaints-section]
            [app.front.view.fee.summary :as fee-summary]
            [app.front.view.inspections.summary-subsection :as inspections-summary-subsection]
            [app.front.view.licence.table :as licence-table]
            [app.front.view.project.conditions :as conditions]
            [app.front.view.property.subs :as property-subs]
            [app.front.view.property.v2.data-section :as property-data-section]
            [app.front.view.property.v2.header :as property-header-v2]
            [app.front.view.property.v2.workspace-reassign :as workspace-reassign]
            [app.front.view.workspace.util :as ws-util]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.util.string :as str-util]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))


(def list-heading :h3.text-lg.mb-4)

(def expanded-container :div.flex.flex-col.gap-4.px-8.py-2)

(defn workspace-expanded
  [tr
   {:application/keys [submitted approved]
    :verdict/keys     [issue-date]
    :workspace/keys   [created]
    :keys             [owners description tz workspace-id]}]
  (let [format-date (<sub [::date-util/date-fn])]
    [expanded-container
     [:div.flex.flex-wrap.gap-x-6.gap-y-4
      (for-frag [[k v] [[:workspace/created created]
                        [:application/submitted submitted]
                        [:verdict/issue-date issue-date]
                        [:application/approved approved]
                        [:property/ws-property-owner (str-util/blank->nil owners)]]]
        (when v
          [:div
           [:div.bx--label.font-bold (tr [k])]
           [:div (if (inst? v)
                   (-> (date-util/in-tz v tz)
                       format-date)
                   v)]]))]
     (when description
       [:div
        [:div.bx--label.font-bold (tr [:description])]
        ;; TODO: Change the call to ui-rt/editor once tiptap is in general use
        [:div [tiptap/editor-impl {:initial-value description
                                   :id            (str workspace-id "-description")
                                   :tr            tr}]]])]))

(defn workspace-table [permit-type]
  (when-let [items (seq (<sub [::property-subs/workspace-items permit-type]))]
    (let [tr (<sub [::property-subs/tr-for-permit-type permit-type])]
      [:div.mt-6
       [list-heading (tr [:dashboard-search/title])]
       [ui-table/modern-responsive-table
        {:items         items
         :cols          (concat [[:workspace/municipal-case-id
                                  :workspace/municipal-case-id]
                                 [:property/ws-status :state {}]
                                 [:property/ws-category :category {}]]
                                (when (not= permit-type :permit-type/CE)
                                  [[:property/ws-work-type :work-type {}]
                                   [:property/ws-work-target :work-target {}]]))
         :expanded-func (partial workspace-expanded tr)
         :tr            tr
         :id-func       :workspace-id
         :link          {:make-href   :ws-link
                         :description ws-util/workspace-link-description}}]])))

(defn month-select [tr]
  (let [selected-months (<sub [::property-subs/complaints-months])]
    [:div.pb-4
     [ui-select/select
      {:id           "month-select"
       :allow-empty? false
       :values       [3 6 9 12 :all]
       :value        (or selected-months 12)
       :label-text   (tr [:complaint/month-select])
       :inline       true
       :val->str     (fn [month]
                       (if (= month :all)
                         (tr [:complaint/all-months])
                         (str month)))
       :on-change    #(>evt [::property-subs/change-complaint-month-selection %])}]]))

(defn complaint-table [tr]
  (when-let [items (seq (<sub [::property-subs/complaint-items]))]
    [:div.mt-6
     [list-heading (tr [:property/complaint-title])]
     [month-select tr]
     [complaints-section/complaint-table tr items false]]))

(defn licence-table [{:keys [tr lang licences]}]
  [ui-table/modern-responsive-table
   {:class      "w-full mt-2"
    :cols       [[:licence/issued-to
                  (fn [{:licence/keys [holder-names]}]
                    (i18n-model/get-text-from-entities-or-map holder-names lang))]

                 (licence-table/state-column tr)

                 [:licence/type
                  (fn [{:licence/keys [category-group-config]}]
                    (config-model/localized-name category-group-config lang))]

                 licence-table/issue-date-column
                 licence-table/expiry-date-column]
    :link       {:make-href   licence-table/href
                 :description :licence/go-to}
    :get-status licence-table/get-status
    :items      licences
    :tr         tr}])

(defn licences-section [{:keys [tr lang]}]
  (when (seq (<sub [::property-subs/licences]))
    (let [show-invalid?    (boolean (<sub [::property-subs/show-invalid-licences?]))
          valid-licences   (<sub [::property-subs/valid-licences])
          invalid-licences (<sub [::property-subs/invalid-licences])]
      [:div.mt-6
       [:div
        [list-heading (tr [:licence/valids])]
        [licence-table (util/mmap {:licences valid-licences}
                                  tr
                                  lang)]]
       (when (seq invalid-licences)
         [:div.mt-4
          [ui/expand-button
           {:title-expanded  (tr [:licence/expireds-hide])
            :title-collapsed (tr [:licence/expireds-show])
            :expanded?       show-invalid?
            :tr              tr
            :expand-handler  #(>evt [::property-subs/toggle-show-invalid-licences?])}]
          (when show-invalid?
            [:div.mt-6
             [licence-table (util/mmap {:licences invalid-licences}
                                       tr
                                       lang)]])])])))

(defn conditions-list [{:keys [permit-type tr]}]
  (when-let [conditions (<sub [::property-subs/conditions-for-permit-type permit-type])]
    [:div.mt-6
     [list-heading (tr [:property/conditions-title])]
     [conditions/conditions-list conditions]]))

(defn make-inspections-subsection-props [{workspace-id  :workspace/id
                                          permit-number :workspace/municipal-case-id
                                          :as           workspace}]
  (let [lang (<sub [:language])]
    {:title    (cc/link {:href       (ws-util/workspace-href workspace)
                         :class-name "font-bold"}
                        (or permit-number workspace-id))
     :subtitle (fee-summary/target-and-category lang workspace)}))

(defn inspection-list [{:keys [permit-type tr]}]
  (when (seq (<sub [::property-subs/inspections-for-permit-type permit-type]))
    [:div.mt-6
     [list-heading (tr [:property/inspections-title])]
     [inspections-summary-subsection/inspections
      (util/mmap {:workspaces-sub        [::property-subs/workspaces-by-permit-type permit-type]
                  :reverse?              true
                  :make-subsection-props make-inspections-subsection-props
                  :hide-empty?           true}
                 tr)]]))

(defn deficiencies-and-orders-list [{:keys [permit-type tr]}]
  (let [orders (<sub [::property-subs/orders-for-permit-type permit-type])]
    (when (or orders (<sub [::property-subs/deficiencies-for-permit-type permit-type]))
      [:div.mt-6
       [list-heading (tr [:property/deficiencies-and-orders])]
       [inspections-summary-subsection/deficiencies-and-orders
        (util/mmap {:show-orders?     (boolean orders)
                    :orders-sub       [::property-subs/orders-for-permit-type permit-type]
                    :deficiencies-sub [::property-subs/deficiencies-for-permit-type permit-type]}
                   tr)]])))

(defn bills-list [{:keys [permit-type tr]}]
  (when (<sub [::property-subs/bills-for-permit-type permit-type])
    [:div.mt-6
     [list-heading (tr [:property/bills])]
     [fee-summary/bills-list
      (util/mmap {:bills-sub [::property-subs/bills-for-permit-type permit-type]}
                 tr)]]))

(defn property-content-section [{:keys [tr]}]
  (let [tabs-with-counts (<sub [::property-subs/available-content-tabs-with-counts])
        tabs             (<sub [::property-subs/available-content-tabs])
        permit-type      (or (<sub [::property-subs/selected-permit-type-tab]) (first tabs))
        lang             (<sub [:language])
        list-ctx         (util/mmap permit-type tr lang)]
    [section/section
     :property-content-items
     {:tr tr}
     :property-view/items-title
     [:div
      [:p.pb-4.text-xs (tr [:property/note])]
      [ui-cs/content-switcher
       {:items     tabs
        :val->str  (fn [k]
                     (str (tr [k]) " (" (get tabs-with-counts k) ")"))
        :current   permit-type
        :on-change #(>evt [::property-subs/set-selected-permit-type-tab %])}]
      (if (= permit-type :permit-type/L)
        [licences-section list-ctx]
        [workspace-table permit-type])
      (when (= permit-type :permit-type/CE)
        [complaint-table tr])
      [conditions-list list-ctx]
      [inspection-list list-ctx]
      [deficiencies-and-orders-list list-ctx]
      [bills-list list-ctx]]]))

(defn- attachment-expanded [tr {:attachment/keys [drawing-number contents]}]
  (when (or drawing-number
            contents)
    [expanded-container
     [:div.flex.flex-wrap.gap-x-6.gap-y-4
      (for-frag [[k v] [[:attachment/drawing-number drawing-number]
                        [:attachment/contents contents]]]
        (when v
          [:div
           [:div.bx--label.font-bold (tr [k])]
           [:div v]]))]]))

(defn- attachment-make-actions [tr ws-id attachment]
  [(when (<sub [::attachment-subs/can-preview? (-> attachment :db/id)])
     (let [latest-version-id (<sub [::attachment-subs/latest-non-markup-version-id (:db/id attachment)])]
       {:title    (tr [:attachment/open-preview])
        :on-click #(>evt [::modals/preview-clicked (-> attachment :db/id) latest-version-id])}))
   {:href  (str "/api/command/attachment/download-selected?workspace-id="
                ws-id
                "&attachment-ids="
                (:db/id attachment))
    :title (tr [:download])
    :icon  i/download}])

(defn- attachments-list [{:keys [tr lang permit-type]}]
  (let [workspaces+attchs (<sub [::property-subs/ws+attachments-for-permit-type permit-type])
        format-date-time  (<sub [::date-util/date-time-fn])]
    (if workspaces+attchs
      [:div
       (for-frag [{:keys [ws attachments]} workspaces+attchs
                  :let [ws-id (-> ws :workspace/id)
                        tz    (-> ws :domain/authority-group :group/tz)]]
         [:div.mt-10
          [:h4.mb-2 ws-id]
          [ui-table/modern-responsive-table
           (util/mmap {:items         attachments
                       :cols          [[:attachment/type (partial attachment-model/attachment-title lang)]
                                       [:file/filename (comp :attachment.version.file/filename
                                                             attachment-model/latest-file-version)]
                                       [:latest-change (comp (fn [{:keys [ts user]}]
                                                               [:<>
                                                                (-> ts (date-util/in-tz tz) format-date-time)
                                                                [:br]
                                                                user])
                                                             :latest-change)]]
                       :expanded-func (partial attachment-expanded tr)
                       :make-actions  (partial attachment-make-actions tr ws-id)
                       :link          {:description (constantly (ws-util/workspace-link-description ws))
                                       :make-href   (constantly (ws-util/workspace-or-resume-application-href ws))}
                       :get-status    (constantly :state/active)}
                      tr)]])]
      [:div (tr [:attachments/none])])))

(defn- workspace-attachments-section
  "Section for displaying workspace attachments with context switcher on permit types.
  The section should be defaulted to be closed, and when opened, it should load in the attachment entities
  for the selected permit type."
  [tr]
  (let [lang        (<sub [:language])
        tabs        (<sub [::property-subs/available-content-tabs])
        permit-type (or (<sub [::property-subs/selected-workspace-attachments-permit-type-tab]) (first tabs))]
    (when (seq tabs)
      [section/section
       :property-workspace-attachments
       {:tr                   tr
        :initially-collapsed? true
        :on-expand            #(>evt [::property-subs/fetch-attachments-for-permit-type permit-type])}
       :property/workspace-attachments
       [:<>
        [modals/attachment-preview-modal (util/mmap tr)]
        [ui-cs/content-switcher
         {:items     tabs
          :val->str  (fn [k] (tr [k]))
          :current   permit-type
          :on-change #(do (>evt [::property-subs/set-selected-workspace-attachments-permit-type-tab %])
                          (>evt [::property-subs/fetch-attachments-for-permit-type %]))}]
        (if (<sub [::property-subs/loading-attachments-for-type? permit-type])
          [:div.pt-4 (cc/loading-spinner {:with-overlay false})]
          [attachments-list (util/mmap permit-type tr lang)])]])))

(defn verify-property-modal [tr]
  (when (<sub [::property-subs/property-being-verified])
    [ui/confirm-modal
     {:tr           tr
      :id           "verify-property-modal"
      :modal-title  (tr [:process.signal/set-property-verified])
      :open?        true
      :on-close     #(rf/dispatch [::property-subs/show-verify-confirm false nil])
      :on-yes-click #(rf/dispatch [::property-subs/set-property-verified])}
     (tr [:application.property/confirm-set-property-verified])]))

(defn verification-error-modal [tr]
  (let [conflicts      (<sub [::property-subs/property-verification-conflicts])
        close-modal-fn #(rf/dispatch [::property-subs/clear-property-verification-conflicts])]
    [ui-modal/composed-input-modal
     {:id       "verification-error-modal"
      :open     (some? conflicts)
      :on-close close-modal-fn
      :size     :md}
     (cc/modal-header {:close-modal close-modal-fn
                       :title       (tr [:error/property-verification-failed])})
     (cc/modal-body
       {}
       [:div (tr [:error/property-verification-conflict] [(str/join ", " conflicts)])])
     (cc/modal-footer
       {}
       (cc/button
         {:kind     :secondary
          :on-click close-modal-fn}
         (tr [:close])))]))

(defn property-view []
  (let [tr       (<sub [::property-subs/tr])
        property (<sub [::property-subs/property])]
    (if (<sub [::property-subs/loading?])
      (cc/loading-spinner)
      [:div.my-5.mx-auto.cloudpermit-page
       [property-header-v2/header tr property]
       [property-data-section/section (util/mmap tr property)]
       [workspace-reassign/section (util/mmap tr)]
       [property-content-section (util/mmap tr)]
       [workspace-attachments-section tr]
       (when (<sub [::property-subs/property-being-deleted])
         [ui/confirm-modal
          {:tr           tr
           :id           "delete-property-modal"
           :modal-title  (tr [:property-view/property-delete-modal-title])
           :open?        true
           :on-close     #(rf/dispatch [::property-subs/show-delete-confirm false nil])
           :on-yes-click #(rf/dispatch [::property-subs/delete-property (<sub [::property-subs/deleting-property-id])])}
          (tr [:property-view/property-delete-confirmation])])

       [verify-property-modal tr]
       [verification-error-modal tr]])))
